// extracted by mini-css-extract-plugin
export default {"SchedulePlitka":"page_SchedulePlitka__wFaqP","title":"page_title__PiVeR","box":"page_box__958Uy","boxInner":"page_boxInner__M52HT"};